import { useEffect, useRef, useMemo } from 'react'

const clickContent = 'openDropDown'

export type DropDownProps = {
  index: number
  active: any
  list: any
  setActive: any
  setVisible: any
  visible: any
}

const DropDown = ({ index, active, list, setActive, setVisible, visible }: DropDownProps) => {
  const dropDownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const isDel = event?.target?.getAttribute?.('class')
      const isContainer = !dropDownRef?.current?.contains(event?.target)
      if (isContainer && !isDel?.includes(clickContent)) {
        setVisible({ ...visible, [index]: false })
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  return (
    <div
      ref={dropDownRef}
      className={`absolute left-0 top-[104%] z-30 box-border max-h-[340px] w-full overflow-auto rounded-lg bg-white ${visible?.[index] ? 'block' : 'hidden'}`}
    >
      <div className={'m-0 box-border h-full flex-1 overflow-hidden p-0 [&:last-child]:border-r-0'}>
        {list?.map((item: any, id: number) => {
          const currentSku = item?.sku || item?.variants?.[0]?.sku
          return (
            <div
              key={id}
              onClick={() => {
                setActive({
                  ...active,
                  [index]: {
                    sku: currentSku,
                    name: item?.name || item?.title,
                    handle: item?.handle,
                  },
                })
                setVisible({ ...visible, [index]: false })
              }}
              title={item?.name || item?.title}
              className={`openDropDown min-xl:text-lg min-xxl:text-lg box-border cursor-pointer truncate px-6 py-4 text-base font-bold [&:hover]:bg-[#EAEAEC]
                ${item?.handle === active?.handle ? 'bg-[#EAEAEC]' : ''}`}
            >
              {item?.name || item?.title}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default DropDown
